import {
  CheckboxField,
  CompanyField,
  DateInputField,
  DropdownField,
  DynamicFormField,
  EmailField,
  FieldKey,
  FieldType,
  FileUploadField,
  NumberInputField,
  PasswordField,
  PhoneNumberField,
  PrivacyPolicyCheckboxField,
  QuestionnaireCheckboxField,
  QuestionnaireDropdownField,
  QuestionnaireRadioField,
  RadioField,
  TextInputField,
  ZipCodeField
} from '@core/data-access/models/dynamic-form-field/dynamic-form-field.model';

export const isTextInputField = (dynamicFormField: DynamicFormField): dynamicFormField is TextInputField =>
  dynamicFormField.type === FieldType.TextInput;

export const isNumberInputField = (dynamicFormField: DynamicFormField): dynamicFormField is NumberInputField =>
  dynamicFormField.type === FieldType.NumberInput;

export const isDateInputField = (dynamicFormField: DynamicFormField): dynamicFormField is DateInputField =>
  dynamicFormField.type === FieldType.DateInput;

export const isFileUploadField = (dynamicFormField: DynamicFormField): dynamicFormField is FileUploadField =>
  dynamicFormField.type === FieldType.FileUpload;

export const isDropdownField = (dynamicFormField: DynamicFormField): dynamicFormField is DropdownField =>
  dynamicFormField.type === FieldType.Dropdown;

export const isQuestionnaireDropdownField = (
  dynamicFormField: DynamicFormField
): dynamicFormField is QuestionnaireDropdownField =>
  dynamicFormField?.isQuestionnaireField && dynamicFormField.type === FieldType.Dropdown;

export const isCheckboxField = (dynamicFormField: DynamicFormField): dynamicFormField is CheckboxField =>
  dynamicFormField.type === FieldType.Checkbox;

export const isQuestionnaireCheckboxField = (
  dynamicFormField: DynamicFormField
): dynamicFormField is QuestionnaireCheckboxField =>
  dynamicFormField?.isQuestionnaireField && dynamicFormField.type === FieldType.Checkbox;

export const isRadioField = (dynamicFormField: DynamicFormField): dynamicFormField is RadioField =>
  dynamicFormField.type === FieldType.Radio;

export const isQuestionnaireRadioField = (
  dynamicFormField: DynamicFormField
): dynamicFormField is QuestionnaireRadioField =>
  dynamicFormField?.isQuestionnaireField && dynamicFormField.type === FieldType.Radio;

export const isEmailField = (dynamicFormField: DynamicFormField): dynamicFormField is EmailField =>
  dynamicFormField.type === FieldType.Email;

export const isPasswordField = (dynamicFormField: DynamicFormField): dynamicFormField is PasswordField =>
  dynamicFormField.type === FieldType.Password;

export const isZipCodeField = (dynamicFormField: DynamicFormField): dynamicFormField is ZipCodeField =>
  dynamicFormField.key === FieldKey.ZipCode;

export const isCompanyField = (dynamicFormField: DynamicFormField): dynamicFormField is CompanyField =>
  dynamicFormField.key === FieldKey.Company;

export const isPhoneNumberField = (dynamicFormField: DynamicFormField): dynamicFormField is PhoneNumberField =>
  dynamicFormField.key === FieldKey.Telephone;

export const isSendToOwnerField = (dynamicFormField: DynamicFormField): dynamicFormField is PhoneNumberField =>
  dynamicFormField.key === FieldKey.SendToOwner;

export const isPrivacyPolicyCheckboxField = (
  dynamicFormField: DynamicFormField
): dynamicFormField is PrivacyPolicyCheckboxField =>
  dynamicFormField.key === FieldKey.Disclaimer || dynamicFormField.key === FieldKey.DisclaimerOptional;
